<mat-accordion class="management-accordion">
    <mat-expansion-panel
        [expanded]="displayMode === DisplayMode.List"
        (opened)="setDisplayMode(DisplayMode.List)"
        (closed)="setDisplayMode(DisplayMode.Form)"
        [ngClass]="{ expanded: displayMode === DisplayMode.Form }"
        hideToggle
        class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Mises en page de la vue"
                createIconText="Ajouter une mise en page"
                importDatasourceName="listLayoutsWorkflows"
                (created)="onListLayoutCreated()"
                (exported)="onListLayoutExported()"
                (imported)="onListLayoutImported()"
                (helped)="onListLayoutHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-list-layouts-workflows-list
            #itemsList
            (itemSelected)="onListLayoutSelected($event)"
            (itemDisplayed)="onListLayoutDisplayed($event)"
            (itemEdited)="onListLayoutEdited($event)"
            (itemDeleted)="onListLayoutDeleted($event)"
            (itemDuplicated)="onListLayoutDuplicated($event)"></app-list-layouts-workflows-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel
            [disabled]="!context?.formContext.formVisible"
            [expanded]="displayMode === DisplayMode.Form"
            (opened)="setDisplayMode(DisplayMode.Form)"
            (closed)="setDisplayMode(DisplayMode.List)"
            hideToggle
            class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onListLayoutDisplayed(context?.formContext.item)"
                    (edited)="onListLayoutEdited(context?.formContext.item)"
                    (helped)="onListLayoutHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-list-layout-workflows-detail
                [context]="context"
                (listLayoutUpdated)="onListLayoutUpdated($event)"
                (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                (canceled)="onBackToList()"></app-list-layout-workflows-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
